import { IDisplayTicket } from '../interfaces/IDisplayTicket';

export function resetTicketsBreak(tickets: IDisplayTicket[]): IDisplayTicket[] {
  const continuations = tickets.filter((tkt) => !!tkt.continuationOf);
  const entire = tickets
    .filter((tkt) => !tkt.continuationOf)
    .map((tkt) => {
      let { items } = tkt;
      const tktContinuations =
        continuations.filter((cnt) => cnt.continuationOf === tkt.id) || [];

      if (tktContinuations.length) {
        for (const continuation of tktContinuations) {
          const { items: continuationItems } = continuation;
          if ((continuationItems || []).length) {
            const comboContinuations =
              continuationItems.filter((item) => !!item.comboItemOf) || [];

            const regularItems =
              continuationItems.filter((item) => !item.comboItemOf) || [];

            const sortedContinuationItems = [
              ...(regularItems || []),
              ...(comboContinuations || []),
            ];

            for (const continuationItem of sortedContinuationItems) {
              const { comboItemOf } = continuationItem;
              if (comboItemOf) {
                items = items.map((item) => {
                  const { subitems } = item;
                  if (item.id === comboItemOf) {
                    subitems.push(continuationItem);
                  }

                  Object.assign(item, {
                    subitems,
                  });

                  return item;
                });
              } else {
                items.push(continuationItem);
              }
            }
          }
        }
      }

      return tkt;
    });

  return entire;
}
